import React, { useState, useEffect } from 'react';
import vr from '../../../../../utils/Verifiers';
import Reporte_siembra_detalle from './Reporte_siembra_detalle';

const ReporteSiembra = (p) => {
    const data_send = p.data_send ?? {};
    const reporte = p.reporte ?? [];
    const dia = p.dia ?? '';
    const semana = p.semana ?? '';
    const [openDetalles, setopenDetalles] = useState(false);

    const numberFormated = (value) => {
        let number = vr.numberFormat(value, 'N/A');
        if (number === 'N/A') return number;
        return number.toLocaleString('en-US');
    }

    return (
        <>
            <div className='text-center shadow m-0 p-2 bg-light round-s col-xl-5 m-1 mb-3' style={{ overflowY: 'auto' }}>
                <div className='w-100 p-1 m-0 text-orange4 h3 dosis text-center'>REP. GENERAL SIEMBRA EN VIVERO</div>
                <table className='table table-sm table-striped'>
                    <thead>
                        <tr >
                            <th scope='col' className='text-start bg-orange4 text-white round-top-left-s'>CONCEPTO</th>
                            <th scope='col' className='text-center bg-orange4 text-white border-end'>SEMANA<span className='text-xs ms-2 text-bold'>{semana}</span></th>
                            <th scope='col' className='text-center bg-orange4 text-white round-top-right-s'>Dia<span className='text-xs ms-2 text-bold'>{dia}</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reporte.map((rep, i) =>
                                <tr key={`reporte-${i}`} >
                                    <th className='text-start'>{rep.nombre}</th>
                                    <td className='border-end'>{numberFormated(rep.semana)}</td>
                                    <td>{numberFormated(rep.dia)}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                <div className='w-100 text-center pt-3'>
                    <button className='btn btn-dark btn-sm shadow bw-400' onClick={() => setopenDetalles(true)}>DETALLES POR BLOQUE</button>
                </div>
            </div>
            {openDetalles && <Reporte_siembra_detalle close={() => setopenDetalles(false)} data_send={data_send} dia={dia} semana={semana} />}
        </>
    )
}

export default ReporteSiembra;